import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = s(
  (t, r) => /* @__PURE__ */ o.jsx(
    a,
    {
      ref: r,
      ...t,
      image: (e) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...e,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M11.5 7.134a1 1 0 0 1 0 1.732l-9 5.196a1 1 0 0 1-1.5-.866V2.804a1 1 0 0 1 1.5-.866zM13 2v12h2V2z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "NextIcon";
export {
  i as NextIcon,
  i as default
};
//# sourceMappingURL=index.js.map
